import React, { useState } from 'react';
import styled from 'styled-components';
import YouTube from 'react-youtube';
import Flex from 'base/components/Flex';
import { getYoutubeId } from './utils';
import theme from '../../../theme';
import BaseWrapper from '../../components/Wrapper';

const Wrapper = styled(BaseWrapper)`
  width: 100%;
  padding-top: 56.25%; // 16:9 aspect ration
  & > div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0; right: 0; bottom: 0; left: 0;
  }
`;

const Placeholder = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0; right: 0; bottom: 0; left: 0;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  color: #fff;
  background: ${theme.colors.medium};
`;

function Video({
  editor, node, isFocused, attributes, readOnly,
}) {
  const [url, setUrl] = useState(node.data.get('url'));
  const videoId = getYoutubeId(url);

  const onChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
    editor.setNodeByKey(node.key, { data: { url: newUrl } });
  };

  // When clicks happen in the input, stop propagation so that the void node
  // itself isn't focused, since that would unfocus the input.
  const onClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Wrapper isFocused={isFocused} readOnly={readOnly} {...attributes}>
      {videoId
        ? (
          <YouTube
            videoId={videoId}
            opts={{
              height: '100%',
              width: '100%',
              playerVars: { autoplay: 0 },
            }}
            style={{
              position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, height: '100%', width: '100%',
            }}
          />
        )
        : (
          <Placeholder>
            {readOnly
              ? (
                <div>Video missing</div>
              )
              : (
                <>
                  <div>Enter Youtube URL</div>
                  <input
                    value={url}
                    onChange={onChange}
                    onClick={onClick}
                  />
                </>
              )}

          </Placeholder>
        )}
    </Wrapper>
  );
}

export default Video;
